<template>
  <div class="contentHome">
    <div class="centerPage">
      <div class="login">
        <div class="leftBG">
          <strong>欢迎使用</strong>
          <h1>心理亦笙</h1>
          <div class="content">
            <span>① 输入用户名、手机号码等基本信息</span>
            <span>② 上传简历</span>
          </div>
          <strong>等待审核...</strong>
        </div>
        <div class="right">
          <span class="title">医生用户注册</span>
          <el-form ref="form" class="doctorLogin registForm" :model="user" label-width="80px" label-suffix="：">

            <el-form-item>
              <span slot="label" class="required-field">真实姓名：</span>
              <el-input v-model="user.name" max placeholder="真实姓名" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio-group v-model="user.gender" class="sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="0">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="required-field">手机号码：</span>
              <el-input v-model="user.mobile" type="tel" placeholder="手机号码" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="签名">
              <el-input v-model="user.signature" placeholder="请写下您对到访者想说的话" maxlength="200"></el-input>
            </el-form-item>
            <el-form-item label="简历">
              <el-upload
                  :accept="uploadAccept"
                  :action="uploadUrl"
                  :before-upload="handleBefore"
                  :before-remove="beforeRemove"
                  :on-error="handleError"
                  :on-success="handleSuccess"
                  multiple
                  name="uploadFile"
                  :file-list="fileList">
                <el-button size="small" class="upload">上传文件</el-button>
                <span class="file_tip">(可上传文件类型：jpg/png/pdf/doc/docx/xls/xlsx)</span>

                <div slot="tip" class="el-upload__tip">附件应包含内容：1.头像 2.简历 3.相关资质证书</div>
              </el-upload>
            </el-form-item>

            <div class="btnGroup flex">
              <el-button class="next" @click="submit" :loading="loading">提交</el-button>
            </div>
            <div class="flex" style="justify-content: center;margin-top: 20px">
              <router-link to="doctorRegist" style="color: #FC7B66;">返回自主注册</router-link>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import base from "@/api/common"

export default {
  name: "resumeDelivery",
  data() {
    return {
      uploadUrl: base.api.upload.private_url.cv,
      uploadAccept: ".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx",
      fileList: [],
      loading: false,
      user: {
        name: '',
        gender: 1,
        mobile: '',
        signature: '',
        files: [],
      },
    }
  },
  inject: ['reload'],
  methods: {
    isAcceptFile(file) {
      if (file && file.name) {
        let index = file.name.lastIndexOf(".");
        if (index >= 0) {
          let suffix = file.name.substring(index);
          if (this.uploadAccept.includes(suffix)) {
            return true;
          }
        }
      }
      return false;
    },
    handleBefore(file) {
      let isAccept = this.isAcceptFile(file);
      if (!isAccept) {
        this.$message.warning("文件类型不支持");
      }
      return isAccept;
    },
    beforeRemove(file, fileList) {
      if (!this.isAcceptFile(file)) {
        return true;
      }
      return this.$confirm(`确定移除 ${file.name}?`);
    },
    handleSuccess(res, file, fileList) {
      if (res.status == 'success') {
        this.user.files.push({fileId: res.id});
      } else {
        $(fileList).each((i, f) => {
          if (f.uid == file.uid) {
            fileList.splice(i, 1);
          }
        });
        this.$message.error("上传失败");
      }
    },
    handleError() {
      this.$message.error('文件上传失败');
    },
    submit() {
      if ($.trim(this.user.name).length === 0) {
        this.$message.warning('真实姓名不能为空');
        return;
      }
      if ($.trim(this.user.mobile).length === 0) {
        this.$message.warning('手机号码不能为空');
        return;
      }
      if (this.user.files.length === 0) {
        this.$message.warning('请先上传附件');
        return;
      }

      this.loading = true;
      this.$ajax.post(base.basePath + 'auth/register-apply/submit', this.user).then(res => {
        if (res.data.status === 'success') {
          this.$messageBox.alert('提交成功', {type: 'success'}).then(() => {
            this.reload();
          }).catch(() => {
            this.reload();
          });
        } else {
          this.$message.error(res.data.message);
        }
        this.loading = false;
      }).catch(err => {
        console.error(err);
        this.$message.error('提交失败,请稍后再试');
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/login.scss';

.login {
  width: auto;
  height: auto;

  .title {
    width: 160px;

    &:before, &:after {
      background: url("~@/assets/img/res_a.png") no-repeat center;
      background-size: cover;
      border: none;
    }

    &:before {
      width: 13px;
      height: 13px;
    }

    &:after {
      width: 10px;
      height: 10px;
    }
  }

  .el-form {
    margin: 20px auto 0;
    padding-right: 20px;
    height: 450px;
    overflow-y: scroll;
    width: 90%;

    .el-form-item {
      margin-bottom: 10px;
    }
  }
}

.leftBG {
  background: url("~@/assets/img/doct_login_bg.png") no-repeat center;
  background-size: cover;
  width: 280px;
}
.right{
  padding: 20px;
}



</style>